import { render, staticRenderFns } from "./InquiryReportPrint.vue?vue&type=template&id=67631a06&scoped=true&"
import script from "./InquiryReportPrint.vue?vue&type=script&lang=js&"
export * from "./InquiryReportPrint.vue?vue&type=script&lang=js&"
import style0 from "./InquiryReportPrint.vue?vue&type=style&index=0&id=67631a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67631a06",
  null
  
)

export default component.exports